<template>
    <div class="transparent-editor-container">
        <div id="container-tag" :style="styleTextFather" class="text-display">
            <span
                v-if="isAddressType"
                :style="styleTextChildren"
                v-html="data.value || data.fake"
            ></span>
            <!-- link de validação como âncora real: o PDF impresso ganha a
                 anotação de link com o href correto, independente de como o
                 navegador renderiza os glifos do texto (backlog#334) -->
            <span v-else-if="validateUrl" :style="styleTextChildren">{{ validatePrefix }}<a
                :href="validateUrl"
                :style="styleTextChildren"
            >{{ validateUrl }}</a></span>
            <span v-else :style="styleTextChildren">{{ data.value || data.fake }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CertificateInputText',

    props: {
        id: String,
        data: Object,
    },

    computed: {
        styleText() {
            return this.data.styleText || {};
        },
        styleTextFather() {
            return {
                textAlign: this.styleText.alignText || 'left',
            };
        },
        styleTextChildren() {
            return {
                fontWeight: this.styleText.textBold,
                fontStyle: this.styleText.textItalic,
                textDecoration: this.styleText.decorationLineText,
                fontSize: this.styleText.letterSize ? `${this.styleText.letterSize}px` : '14px',
                color: this.styleText.textColor || '#000',
                fontFamily: this.styleText.fontFamily || 'Roboto',
                whiteSpace: 'pre-wrap',
                // ligaduras ("fi" -> ﬁ) quebram a extração/deteção do link
                // no PDF impresso pelo Safari/Firefox (backlog#334)
                fontVariantLigatures: 'none',
            };
        },
        isAddressType() {
            return this.data && this.data.type === 'address';
        },
        validateUrl() {
            if (!this.data || !['validate', 'validate_link'].includes(this.data.type)) return null;
            const text = this.data.value || this.data.fake || '';
            const match = text.match(/https?:\/\/\S+/);
            return match ? match[0] : null;
        },
        validatePrefix() {
            const text = this.data.value || this.data.fake || '';
            return this.validateUrl
                ? text.slice(0, text.indexOf(this.validateUrl))
                : text;
        },
    },
};
</script>

<style scoped>
.transparent-editor-container {
    position: relative;
    width: 100%;
    height: 100%;
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

.text-display {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 5;
    padding: 4px;
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

/* Remover fundo branco do container pai */
:deep(.vdr),
:deep(.vdr *) {
    background: transparent !important;
    background-color: transparent !important;
    box-shadow: none !important;
}
</style>
